import { Stack, useMediaQuery, useTheme } from '@mui/material';

import { SidebarRouteButton } from '../SidebarRouteButton';
import { useRoutes } from '../../hooks';

export function SidebarRouteList() {
  const { filteredGroupRoutes } = useRoutes();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Stack gap={isMobile ? 1 : 3}>
      {filteredGroupRoutes.map(({ route }) => (
        <SidebarRouteButton route={route} key={route.path} />
      ))}
    </Stack>
  );
}
